// Color Settings Component
// Brand color picker with live preview

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Palette, MessageCircle } from 'lucide-react';

const ColorSettings = ({ primaryColor, secondaryColor, onChange }) => {
  return (
    <Card className="border-slate-200">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <Palette className="w-5 h-5 text-teal-500" />
          Colors
        </CardTitle>
        <CardDescription>
          Choose your brand colors for the widget and emails
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label htmlFor="primary_color">Primary Color</Label>
          <div className="flex items-center gap-3 mt-1">
            <input
              type="color"
              id="primary_color"
              value={primaryColor}
              onChange={(e) => onChange('primary_color', e.target.value)}
              className="w-12 h-10 rounded border border-slate-200 cursor-pointer"
              data-testid="primary-color-input"
            />
            <Input
              value={primaryColor}
              onChange={(e) => onChange('primary_color', e.target.value)}
              placeholder="#0d9488"
              className="flex-1"
            />
          </div>
        </div>
        
        <div>
          <Label htmlFor="secondary_color">Secondary Color</Label>
          <div className="flex items-center gap-3 mt-1">
            <input
              type="color"
              id="secondary_color"
              value={secondaryColor}
              onChange={(e) => onChange('secondary_color', e.target.value)}
              className="w-12 h-10 rounded border border-slate-200 cursor-pointer"
              data-testid="secondary-color-input"
            />
            <Input
              value={secondaryColor}
              onChange={(e) => onChange('secondary_color', e.target.value)}
              placeholder="#0f172a"
              className="flex-1"
            />
          </div>
        </div>
        
        {/* Preview */}
        <div className="pt-4 border-t">
          <p className="text-sm text-slate-500 mb-2">Preview</p>
          <div className="flex items-center gap-2">
            <div 
              className="w-12 h-12 rounded-full flex items-center justify-center"
              style={{ backgroundColor: primaryColor }}
            >
              <MessageCircle className="w-6 h-6 text-white" />
            </div>
            <div 
              className="px-4 py-2 rounded-lg text-white text-sm"
              style={{ backgroundColor: secondaryColor }}
            >
              Widget Header
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ColorSettings;
